import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  Grid,
  Card,
  CardContent,
  Typography,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as Icons from "@fortawesome/free-solid-svg-icons";
import { faBook } from "@fortawesome/free-solid-svg-icons";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../config/firebase";
import ModalDialogTitle from "../../common/ModalDialogTitle";

const Resources = () => {
  const [open, setOpen] = useState(false);
  const [resources, setResources] = useState([]);

  useEffect(() => {
    const fetchResources = async () => {
      const querySnapshot = await getDocs(collection(db, "resources"));
      const resourcesData = querySnapshot.docs.map((doc) => doc.data());
      setResources(resourcesData);
    };

    fetchResources();
  }, []);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        startIcon={<FontAwesomeIcon icon={faBook} />}
        onClick={handleClickOpen}
      >
        Resources
      </Button>
      <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
        <ModalDialogTitle
          onClose={handleClose}
          style={{ backgroundColor: "#AC1A2F", color: "white" }}
        >
          Click on the links below for quick information on the topics listed
        </ModalDialogTitle>
        <DialogContent sx={{ marginTop: 2 }}>
          <Grid container spacing={2}>
            {resources.map((resource, index) => (
              <Grid item xs={12} sm={4} key={index}>
                <Card sx={{ height: "100%" }}>
                  <CardContent>
                    <Typography variant="h6" component="div">
                      <a
                        href={resource.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        <FontAwesomeIcon
                          icon={Icons[resource.icon]}
                          style={{ color: resource.iconColor, marginRight: 8 }}
                        />
                        {resource.title}
                      </a>
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Resources;
